import CITY_INITIAL_STATE from './city.initial-state';
import CITY_MUTATIONS from './city.mutations';
import CITY_GETTERS from './city.getters';
import CITY_ACTIONS from './city.actions';

// ============================================================================
// :: CITY MODULE STORE
// ============================================================================

const cityStore = {
  name: 'city',
  namespaced: true,
  state: CITY_INITIAL_STATE(),
  mutations: CITY_MUTATIONS,
  actions: CITY_ACTIONS,
  getters: CITY_GETTERS,
};

export {
  cityStore,
};
